import HeaderBox from '../../../../components/generic/arpariBoxes/headerBox'
import TableWithLoadingWrapper from '../../../../components/generic/dataGrid'
import SearchBar from '../../bankAccountsAll/tempComponents/searchBar'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import theme from '../../../../helpers/theme'
import { useEffect, useState, useCallback } from 'react'
import { backendGetRequest } from '../../../../helpers/callBackend'
import Typography from '@mui/material/Typography'
import checkFlag from '../../../../helpers/featureFlags'
import TransactionCounterpartiesMergeButton from './TransactionCounterpartiesMergeButton'
import TransactionsCounterpartiesRowDropdown from './TransactionsCounterpartiesRowDropdown'
import PermissionGate from '../../../../helpers/PermissionGate'
import { Link } from 'react-router-dom'
import FormattedTabs from '../../../../components/generic/formattedTabs'
import IgnoredCounterpartiesTable from './ignoredCounterparties/IgnoredCounterpartiesTable'
import CounterpartiesTags from './counterpartiesTags/CounterpartiesTags'
import { documentTitle } from '../../../../components/header/documentTitle'
import CreateNewTransactionCounterparty from './CreateNewTransactionCounterparty'

const TransactionsCounterparties = () => {
  const [originalTableData, setOriginalTableData] = useState([])
  const [displayedTableData, setDisplayedTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [selectedRecords, setSelectedRecords] = useState([])
  const [totalRecords, setTotalRecords] = useState(-1)
  const [originalIgnored, setOriginalIgnored] = useState([])
  const [displayIgnored, setDisplayIgnored] = useState([])
  const [loadingIgnored, setLoadingIgnored] = useState(false)
  const [totalIgnored, setTotalIgnored] = useState(-1)

  const getCounterPartiesPage = async (pageNum) => {
    try {
      const cptyResp = await backendGetRequest('/api/transactions/counterparties', {
        params: {
          page_index: pageNum,
          filter_params: {
            is_valid: true,
            clean_counterparty: 'None',
          },
        },
      })
      const cptyArray = cptyResp.data?.data
      setOriginalTableData((prevState) => [...prevState, ...cptyArray])
    } catch {
      return
    }
  }

  const getCounterParties = useCallback(async () => {
    setOriginalTableData([])
    setDisplayedTableData([])
    setIsLoading(true)
    let totalPages = 0
    try {
      const pageInfo = await backendGetRequest('/api/transactions/counterparties', {
        params: {
          page_index: 0,
          filter_params: {
            is_valid: true,
            clean_counterparty: 'None',
          },
        },
      })
      totalPages = pageInfo.data?.total_pages
      setTotalRecords(pageInfo.data?.total_records)
    } catch {
      return
    }

    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      getCounterPartiesPage(pageNum)
    }
  }, [])

  const getIgnoredCounterpartiesPage = async (pageNum) => {
    try {
      const cptyResp = await backendGetRequest('/api/transactions/counterparties', {
        params: {
          page_index: pageNum,
          filter_params: {
            is_valid: false,
          },
        },
      })
      const cptyArray = cptyResp.data?.data
      setOriginalIgnored((prevState) => [...prevState, ...cptyArray])
    } catch {
      return
    }
  }
  const getIgnoredCounterParties = useCallback(async () => {
    setOriginalIgnored([])
    setDisplayIgnored([])
    setLoadingIgnored(true)
    let totalPages = 0
    try {
      const pageInfo = await backendGetRequest('/api/transactions/counterparties', {
        params: {
          page_index: 0,
          filter_params: {
            is_valid: false,
          },
        },
      })
      totalPages = pageInfo.data?.total_pages
      setTotalIgnored(pageInfo.data?.total_records)
    } catch {
      return
    }

    for (let pageNum = 1; pageNum <= totalPages; pageNum++) {
      getIgnoredCounterpartiesPage(pageNum)
    }
  }, [])

  const onRowSelect = (selectedRows) => {
    const selectedRowObjects = displayedTableData.filter((row) => selectedRows.includes(row.id))
    setSelectedRecords(selectedRowObjects)
  }

  const removeRowsById = (rowIds) => {
    const newRows = originalTableData.filter((row) => !rowIds.includes(row.id))
    setTotalRecords((prevState) => prevState - rowIds.length)
    setDisplayedTableData(newRows)
    setOriginalTableData(newRows)
  }

  const replaceRowById = (rowId, newRow) => {
    let newRows = originalTableData.filter((row) => rowId !== row.id)
    newRows = [...newRows, newRow]
    setDisplayedTableData(newRows)
    setOriginalTableData(newRows)
  }

  const addToCleanTable = (newClean) => {
    let newOriginal = [...originalTableData]
    newOriginal.push(newClean)
    setTotalRecords(newOriginal.length)
    setOriginalTableData(newOriginal)
    setDisplayedTableData(newOriginal)
  }

  const addToIgnoredTable = (newIgnored) => {
    let newOriginal = [...originalIgnored]
    newOriginal.push(newIgnored)
    setOriginalIgnored(newOriginal)
    setDisplayIgnored(newOriginal)
  }

  const removeFromIgnoredTable = (rowId) => {
    const newRows = originalIgnored.filter((row) => rowId !== row.id)
    setTotalIgnored((prevState) => prevState - 1)
    setOriginalIgnored(newRows)
    setDisplayIgnored(newRows)
  }

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
      renderCell: (params) => {
        const { id, name } = params.row
        return <Link to={`/transaction-counterparties/details/${id}`}>{name}</Link>
      },
    },
    {
      field: 'description',
      headerName: 'Description',
      flex: 1,
      renderCell: (params) => {
        const { description } = params.row
        return <Typography variant='primary'>{description}</Typography>
      },
    },
    {
      field: 'dropdown',
      headerName: '',
      flex: 0.5,
      align: 'right',
      renderCell: (params) => {
        return (
          <PermissionGate requiredRole='dashboardEditor'>
            <TransactionsCounterpartiesRowDropdown
              transactionCounterparty={params.row}
              onSuccessfulEdit={replaceRowById}
              removeRowsById={removeRowsById}
              addToIgnoredTable={addToIgnoredTable}
            />
          </PermissionGate>
        )
      },
    },
  ]

  useEffect(() => {
    if (!checkFlag('transactionsCounterparties')) {
      return
    }
    getCounterParties()
    getIgnoredCounterParties()
    documentTitle()
  }, [getCounterParties, getIgnoredCounterParties])

  useEffect(() => {
    if (totalRecords >= 0 && originalTableData.length >= totalRecords) {
      setIsLoading(false)
      setDisplayedTableData(originalTableData)
    }
  }, [originalTableData, totalRecords])

  useEffect(() => {
    if (totalIgnored >= 0 && originalIgnored.length >= totalIgnored) {
      setLoadingIgnored(false)
      setDisplayIgnored(originalIgnored)
    }
  }, [originalIgnored, totalIgnored])

  return (
    <Box sx={{ overflow: 'auto', maxHeight: '99%' }}>
      <Box sx={{ margin: theme.dashboard.margins }}>
        <Stack spacing={1}>
          <HeaderBox title='Counterparties' />
          <FormattedTabs
            defaultActiveKey={0}
            tabPanes={[
              {
                title: 'Counterparties',
                key: 0,
                body: (
                  <Stack spacing={1}>
                    <Stack spacing={1} direction='row'>
                      <SearchBar
                        originalTableData={originalTableData}
                        updateTableState={setDisplayedTableData}
                        searchKeys={[['name'], ['description']]}
                        isLoading={isLoading}
                      />
                      <TransactionCounterpartiesMergeButton
                        selectedRows={selectedRecords}
                        onSuccessfulMerge={removeRowsById}
                      />
                      <CreateNewTransactionCounterparty />
                    </Stack>
                    <TableWithLoadingWrapper
                      noRowsLabel={checkFlag('transactionsCounterparties') ? 'No rows' : 'Coming soon'}
                      checkboxSelection={true}
                      onRowSelectionModelChange={(newModel) => onRowSelect(newModel)}
                      selectionModel={selectedRecords}
                      loading={isLoading}
                      pagination={{
                        paginationModel: {
                          pageSize: 25,
                          page: 0,
                        },
                      }}
                      pageSizeOptions={[5, 10, 25]}
                      getRowId={(record) => record.id}
                      columns={columns}
                      dataSource={displayedTableData}
                      sortModel={[
                        {
                          field: 'name',
                          sort: 'asc',
                        },
                      ]}
                    />
                  </Stack>
                ),
              },
              {
                title: 'Tags',
                key: 1,
                body: <CounterpartiesTags />,
              },
              {
                title: 'Ignored',
                key: 2,
                body: (
                  <IgnoredCounterpartiesTable
                    originalTableData={originalIgnored}
                    displayTableData={displayIgnored}
                    setDisplayTableData={setDisplayIgnored}
                    isLoading={loadingIgnored}
                    removeFromIgnoredTable={removeFromIgnoredTable}
                    addToCleanTable={addToCleanTable}
                  />
                ),
              },
            ]}
          />
        </Stack>
      </Box>
    </Box>
  )
}

export default TransactionsCounterparties
